import React from 'react'
import * as Styled from './styled'

interface Props {
  onClickReview: () => void
  onClickIgnore: () => void
  id: string
}

export const Validator: React.FunctionComponent<Props> = ({
  onClickReview,
  onClickIgnore,
  id,
}) => {
  return (
    <Styled.Container>
      <Styled.AlertContainer>
        <Styled.ExclamationPoint
          name="exclamationPoint"
          title={`exclamationPoint-${id}`}
        />
        <Styled.Text>Missing info</Styled.Text>
      </Styled.AlertContainer>
      <Styled.ButtonContainer>
        <Styled.ReviewButton
          size="small"
          data-test="review-bibliography-citation"
          onClick={onClickReview}
        >
          Review
        </Styled.ReviewButton>
        <Styled.IgnoreButton
          size="small"
          data-test="ignore-bibliography-citation"
          onClick={onClickIgnore}
        >
          Ignore
        </Styled.IgnoreButton>
      </Styled.ButtonContainer>
    </Styled.Container>
  )
}

export default Validator
